// Import react lib
import { createContext, useState, useEffect } from 'react';

// Import log services
import { initVisit } from '../services/log';

export const VisitContext = createContext();

export function VisitProvider({ children, isAdmin = false, isLoading = true }) {
    // Store the visit id into a state
    const [visitId, setVisitId] = useState(null);

    useEffect(() => {
        setVisitId(null);

        // If user is admin do nothing
        if (isAdmin || isLoading) {
            return;
        }

        async function fetchVisitId() {
            // Try to get the visit id if it exist
            try {
                const currentVisitId = await initVisit();
                setVisitId(currentVisitId);
            } catch (err) {
                setVisitId(null);
            }
        }

        fetchVisitId();
    }, [isAdmin, isLoading]);

    // Return the context provider
    return (
        <VisitContext.Provider value={{ visitId }}>
            {children}
        </VisitContext.Provider>
    );
}
